export enum RoutePath {
  ROOT = "/",
  GAME = "/game",
  PAGE404 = "*",
}
